import cx from 'classnames';

import { useReport, useVehicle, REPORT_OUTCOMES, MessagingCard } from '@motorway/motorway-handshake-components';
import type { ReportInspection } from '@motorway/motorway-handshake-components/types';

import { formatCurrency } from '../../helpers';
import { ADJUSTMENT_QUESTION } from '../../pages/Adjustment/Adjustment.helpers';
import { ReportCardDamage } from './ReportCardStatus/ReportCardDamage';
import { ReportCardPerfect } from './ReportCardStatus/ReportCardPerfect';

import styles from './ReportCard.module.scss';

export const ReportCard = ({ className }: { className?: string }) => {
  const { report } = useReport();
  const { vehicle: { enquiry } } = useVehicle();

  const { inspection } = report;
  const { closingBid } = enquiry;

  const {
    [
    ADJUSTMENT_QUESTION.ADJUSTMENT_AMOUNT as keyof ReportInspection['proposedPrice']
    ]: adjustmentAmount = 0,
  } = inspection;

  const card = (inspection.outcome === REPORT_OUTCOMES.PERFECT)
    ? (
        <ReportCardPerfect />
      )
    : (
        <ReportCardDamage />
      );

  return (
    <div className={cx(styles.component, className)}>
      <MessagingCard
        className={styles.card}
        heading="Inspection report"
        action={(
          <div className={cx({ [styles.noIssues]: true })}>
            {card}
            <ul>
              <li>
                <span>Sold price</span>
                <span>
                  {formatCurrency(closingBid.value)}
                </span>
              </li>
              <li>
                <span>Reduced amount</span>
                <span className={cx({ [styles.reduced]: adjustmentAmount })}>{formatCurrency((adjustmentAmount) * -1)}</span>
              </li>
              <li>
                <span>Final offer</span>
                <span>
                  {formatCurrency(closingBid.value - adjustmentAmount)}
                </span>
              </li>
            </ul>
          </div>
        )}
      />
    </div>
  );
};
